// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import * as GlobalActions from 'actions/global_actions.jsx';
import LocalizationStore from 'stores/localization_store.jsx';
import {Client4} from 'mattermost-redux/client';

import {IntlProvider} from 'react-intl';

import PropTypes from 'prop-types';

import React from 'react';
import FastClick from 'fastclick';
import $ from 'jquery';

import {browserHistory} from 'react-router/es6';
import UserStore from 'stores/user_store.jsx';
import BrowserStore from 'stores/browser_store.jsx';
import Constants from 'utils/constants.jsx';

export default class Root extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            locale: LocalizationStore.getLocale(),
            translations: LocalizationStore.getTranslations()
        };

        this.localizationChanged = this.localizationChanged.bind(this);
        this.redirectIfNecessary = this.redirectIfNecessary.bind(this);

        const segmentKey = Constants.DIAGNOSTICS_SEGMENT_KEY;
        const dropboxAppKey = window.mm_config.DropboxAppKey;

        // Ya....
        /*eslint-disable */
        if (segmentKey != null && segmentKey !== '' && window.mm_config.DiagnosticsEnabled === 'true') {
            !function(){var analytics=global.window.analytics=global.window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","group","track","ready","alias","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t){var e=document.createElement("script");e.type="text/javascript";e.async=!0;e.src=("https:"===document.location.protocol?"https://":"http://")+"cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};analytics.SNIPPET_VERSION="3.0.1";
                analytics.load(segmentKey);

                analytics.page('ApplicationLoaded', {
                        path: '',
                        referrer: '',
                        search: '',
                        title: '',
                        url: '',
                    },
                    {
                        context: {
                            ip: '0.0.0.0'
                        },
                        anonymousId: '00000000000000000000000000'
                    });
            }}();
        }
        /*eslint-enable */

        // Baidu Map
        if ( window.mm_config.EnableBaiduMap === 'true' && window.mm_config.BaiduMapApiKey !== '' ) {

            window.baiduMapAsyncInit = function() {
                var event = new Event('baidu_map_loaded');
                window.dispatchEvent(event);
            }

            !function(){

                var g = document.getElementById('baiduMapApi');

                if (g) {
                    window.console && console.error && console.error("Baidu map api included twice.");
                } else {

                    var key = '';

                    if (window.mm_config.BaiduMapApiKey) {
                        key = '&ak=' +  window.mm_config.BaiduMapApiKey;
                    }
                    var e = document.createElement("script");
                    e.type = "text/javascript";
                    e.async = !0;
                    e.defer = true;
                    e.src = " https://api.map.baidu.com/api?v=3.0" + key + "&callback=baiduMapAsyncInit"; //&key=您的JS API开发者Key

                    e.id = "baiduMapApi";
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(e, n)
                }
            }();
        }
        // google drive || google map
        if ( window.mm_config.EnableGoogleDrive === 'true' ) {

            !function(){

                var g = document.getElementById('googleapi');

                if (g) {
                    window.console && console.error && console.error("google api included twice.");
                } else {
                    var e = document.createElement("script");
                    e.type = "text/javascript";
                    e.async = !0;
                    e.defer = true;
                    e.src = "https://apis.google.com/js/api.js";
                    e.id = "googleapi";
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(e, n)
                }
            }();
        }
        if ( window.mm_config.EnableGoogleMap  === 'true' ) {

            window.gapiLoaded = function(){
                var event = new Event('gapi_loaded');
                window.dispatchEvent(event);
            }

            !function(){

                var g = document.getElementById('googleMapApi');

                if (g) {
                    window.console && console.error && console.error("google map api included twice.");
                } else {
                    var key = '';
                    if (window.mm_config.GoogleMapApiKey) {
                        key =  window.mm_config.GoogleMapApiKey;
                    }

                    var e = document.createElement("script");
                    e.type = "text/javascript";
                    e.async = !0;
                    e.defer = true;
                    e.src="https://maps.googleapis.com/maps/api/js?key=" + key + "&callback=gapiLoaded";
                    e.id = "googleMapApi";
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(e, n)
                }
            }();
        }

        // dropbox chooser
        if (dropboxAppKey != null && dropboxAppKey !== '' && window.mm_config.EnableDropbox === 'true') {
            !function(){

                var d = document.getElementById('dropboxjs');

                    if (d) {
                        window.console && console.error && console.error("dropboxjs chooser included twice.");
                    } else {

                        var load = function(t) {
                            var e = document.createElement("script");
                            e.type = "text/javascript";
                            e.async = !0;
                            e.src = "https://www.dropbox.com/static/api/2/dropins.js";
                            e.id = "dropboxjs";
                            e.setAttribute("data-app-key", t);
                            var n = document.getElementsByTagName("script")[0];
                            n.parentNode.insertBefore(e, n)
                        };

                    load(dropboxAppKey);
                }
            }();
        }
            
         // Jitsi Meet
        if (global.mm_config.EnableWebrtc === 'true' ) {
                !function(){
                    var d = document.getElementById('jitsimeetapi');
                        if (d) {
                            window.console && console.error && console.error("jitsimeetapi included twice.");
                        } else {
                                var e = document.createElement("script");
                                e.type = "text/javascript";
                                e.async = !0;
                                e.src = "https://" + global.mm_config.MeetingServer + "/external_api.min.js";
                                e.id = "jitsimeetapi";
                                var n = document.getElementsByTagName("script")[0];
                                n.parentNode.insertBefore(e, n)                          
                       }
                }();
        }



        if (global.window.mm_config.EnableShareToFacebook === 'true' && global.window.mm_config.FacebookAppId ) {

            window.fbAsyncInit = function() {
                FB.init({
                    appId            : global.window.mm_config.FacebookAppId,
                    autoLogAppEvents : true,
                    xfbml            : false,
                    version          : global.window.mm_config.FacebookSDKVersion
                });
            };

            (function(d, s, id){
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s); js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js"
                // js.src = "https://connect.facebook.net/en_US/sdk/debug.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

        }

        if (global.window.mm_config.EnableSignUpWithApple === 'true') {
            let locale =  navigator.language || '';


            locale = locale.replace('-', '_');

            if (locale.indexOf('_') >= 0) {
                var temp = locale.split("_");
                temp[1] = temp[1].toUpperCase();
                locale = temp.join("_");
            }

            const supportedLocale = ["ar_SA", "ca_ES", "cs_CZ", "da_DK", "de_DE", "el_GR", "en_GB", "en_US", "es_ES", "es_MX", "fi_FI", "fr_CA",
                "fr_FR", "hr_HR", "hu_HU", "id_ID", "it_IT", "iw_IL", "ja_JP", "ko_KR", "ms_MY", "nl_NL", "no_NO", "pl_PL", "pt_BR", "pt_PT",
                "ro_RO", "ru_RU", "sk_SK", "sv_SE", "th_TH", "tr_TR", "uk_UA", "vi_VI", "zh_CN", "zh_HK",  "zh_TW"];

            if (supportedLocale.indexOf(locale) === -1) {
                locale = 'en_US';
            }

            (function(d, s, id){
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;

                js = d.createElement(s); js.id = id;
                js.async = !0;
                js.defer = true;
                js.src = `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${locale}/appleid.auth.js`;
                js.onload  = function(){
                    var event = new Event('appleid.auth_loaded');
                    window.dispatchEvent(event);

                }
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'apple-authjs'));

        }

        if (global.window.mm_license.IsCordchatEnterprise === 'false') {
            !function(){
                var s = document.getElementById('stripe-js');
                if (s) {
                    window.console && console.error && console.error("stripe-js included twice.");
                } else {
                    var e = document.createElement("script");
                    e.type = "text/javascript";
                    e.async = !0;
                    e.src = "https://js.stripe.com/v3/";
                    e.id = "stripe-js";
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(e, n)
                }
            }();
        }

        // if (global.window.mm_config.EnableShareToWeibo === 'true') {
        //     (function(d, s, id){
        //         var js, fjs = d.getElementsByTagName(s)[0];
        //         if (d.getElementById(id)) return;
        //         js = d.createElement(s); js.id = id;
        //         js.src = "http://tjs.sjs.sinajs.cn/open/api/js/wb.js?appkey=3456376465";
        //         js.type = "text/javascript";
        //         js.charset = "utf-8";
        //         fjs.parentNode.insertBefore(js, fjs);
        //     }(document, 'script', 'weibo-jssdk'));
        // }



        // Force logout of all tabs if one tab is logged out
        $(window).bind('storage', (e) => {
            // when one tab on a browser logs out, it sets __logout__ in localStorage to trigger other tabs to log out
            if (e.originalEvent.key === '__logout__' && e.originalEvent.storageArea === localStorage && e.originalEvent.newValue) {
                // make sure it isn't this tab that is sending the logout signal (only necessary for IE11)
                if (BrowserStore.isSignallingLogout(e.originalEvent.newValue)) {
                    return;
                }

                console.log('detected logout from a different tab'); //eslint-disable-line no-console
                GlobalActions.emitUserLoggedOutEvent('/', false);
            }

            if (e.originalEvent.key === '__login__' && e.originalEvent.storageArea === localStorage && e.originalEvent.newValue) {
                // make sure it isn't this tab that is sending the logout signal (only necessary for IE11)
                if (BrowserStore.isSignallingLogin(e.originalEvent.newValue)) {
                    return;
                }

                console.log('detected login from a different tab'); //eslint-disable-line no-console
                location.reload();
            }
        });

        // Fastclick
        FastClick.attach(document.body);
    }

    localizationChanged() {
        const locale = LocalizationStore.getLocale();

        Client4.setAcceptLanguage(locale);
        this.setState({locale, translations: LocalizationStore.getTranslations()});
    }

    redirectIfNecessary(props) {
        if (props.location.pathname === '/') {
            if (UserStore.getNoAccounts()) {
                browserHistory.push('/signup_user_complete');
            } else if (UserStore.getCurrentUser()) {
                GlobalActions.redirectUserToDefaultTeam();
            } else {
                browserHistory.push('/login' + window.location.search);
            }
        }
    }

    componentWillReceiveProps(newProps) {
        this.redirectIfNecessary(newProps);
    }

    componentWillMount() {
        // Redirect if Necessary
        this.redirectIfNecessary(this.props);
    }

    componentDidMount() {
        // Setup localization listener
        LocalizationStore.addChangeListener(this.localizationChanged);

        // Get our localizaiton
        GlobalActions.loadCurrentLocale();
    }

    componentWillUnmount() {
        LocalizationStore.removeChangeListener(this.localizationChanged);
    }

    render() {
        if (this.state.translations == null || this.props.children == null) {
            return <div/>;
        }

        return (
            <IntlProvider
                locale={this.state.locale}
                messages={this.state.translations}
                key={this.state.locale}
            >
                {this.props.children}
            </IntlProvider>
        );
    }
}

Root.defaultProps = {
};

Root.propTypes = {
    children: PropTypes.object
};



// WEBPACK FOOTER //
// ./components/root.jsx